export default {
    reset_password_title: "Restablecer la contraseña",
    reset_password_message: "¿Desea restablecer la contraseña? Se enviará un correo electrónico con las instrucciones para establecer la nueva contraseña",
    reset_password_success_message: "El correo electrónico ha sido enviado",
    reset_password_error_message: "No se pudo enviar el correo electrónico debido a un error",
    reset_password_new_password: "Nueva contraseña",
};